module.exports = __webpack_public_path__ + "assets/08ceb979e645a85695cfe0307dbceace.png";